import React, { Fragment, useState, useEffect, useContext } from 'react'

import Header from './Header'
import Footer from './Footer'

import { Helmet } from "react-helmet-async";

const Message = ({ history, title, description, type, action, links }) => {

    title = title ?? 'Message title'
    description = description ?? 'Message description.'
    type = type ? ('border-' + type) : 'border'

    return (
        <Fragment>
            <Header history={history} />
            <main className="py-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-xl-6 mx-auto">
                            <div className={"card " + type}>
                                <div className="card-body">

                                    <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                                    <h1 className="card-title">{title}</h1>
                                    <p className="card-text">{description}</p>
                                    {action && <a href={action.to} className={"btn btn-" + (action.type ?? 'primary')}>{action.label}</a>}
                                    {links && links.map((link, i) =>
                                        <a key={i} href={link.to} className={"btn btn-" + (link.type ?? 'link')}>{link.label}</a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </Fragment>
    )
}

export default Message
